import React from 'react';
import SupplierTemplateUploadFlow from '../components/SupplierTemplateUploadFlow';

// Thin route wrapper (B3) — page chrome only. The dropzone/result lifecycle
// lives in SupplierTemplateUploadFlow, shared with the request-tailored
// upload page (RequestUploadPage).
export default function TemplateUploadPage() {
  // Item B1: the page HEADER stays flush-left/full-width, matching every
  // other page on the platform — only the card/list content below it
  // centers itself. SupplierTemplateUploadFlow's own inner states each pick
  // their own comfortable width and center with their own `mx-auto`, so
  // this page doesn't wrap them in a second, competing width constraint.
  return (
    <div className="flex flex-col gap-6">
      <div>
        <h1 className="text-xl font-bold text-slate-800 m-0">Template Upload</h1>
        <p className="text-sm text-slate-500 mt-1 m-0">
          Already filled in the EU CBAM communication template? Drop it here — we'll turn it into
          draft emissions data for you to review before anything is shared.
        </p>
      </div>

      <SupplierTemplateUploadFlow />
    </div>
  );
}
